import { Icon } from '@types';

export const Meter = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 74.3 74.3"
			xmlSpace="preserve"
		>
			<style type="text/css">
				{
					'\n\t.st0-meter{fill:none;stroke:#010101;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n'
				}
			</style>
			<g>
				<path
					className="st0-meter"
					d="M4.4,30.9h0.3c1.9,0,3.4,1.5,3.4,3.4v35.7c0,1.9-1.5,3.4-3.4,3.4H4.4c-1.9,0-3.4-1.5-3.4-3.4V34.3 C1,32.4,2.5,30.9,4.4,30.9z"
				/>
				<g>
					<line className="st0-meter" x1={8.1} y1={34.3} x2={26.7} y2={34.3} />
					<line className="st0-meter" x1={26.7} y1={69.9} x2={8.1} y2={69.9} />
					<line className="st0-meter" x1={47.7} y1={34.3} x2={66.2} y2={34.3} />
					<line className="st0-meter" x1={66.2} y1={69.9} x2={47.7} y2={69.9} />
				</g>
				<path
					className="st0-meter"
					d="M70,73.3h-0.3c-1.9,0-3.4-1.5-3.4-3.4V34.3c0-1.9,1.5-3.4,3.4-3.4H70c1.9,0,3.4,1.5,3.4,3.4v35.7 C73.3,71.8,71.8,73.3,70,73.3z"
				/>
				<circle className="st0-meter" cx={37.2} cy={52.1} r={20.7} />
				<g>
					<line className="st0-meter" x1={37.2} y1={35.2} x2={37.2} y2={38.1} />
					<g>
						<line className="st0-meter" x1={54.1} y1={52.1} x2={51.2} y2={52.1} />
						<line className="st0-meter" x1={23.2} y1={52.1} x2={20.2} y2={52.1} />
					</g>
				</g>
				<g>
					<line className="st0-meter" x1={28.7} y1={37.5} x2={30.2} y2={40} />
					<line className="st0-meter" x1={51.8} y1={43.7} x2={49.3} y2={45.1} />
				</g>
				<g>
					<line className="st0-meter" x1={22.5} y1={43.7} x2={25} y2={45.1} />
					<line className="st0-meter" x1={45.6} y1={37.5} x2={44.2} y2={40} />
				</g>
				<path
					className="st0-meter"
					d="M40.1,52.1c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9S40.1,50.5,40.1,52.1z"
				/>
				<line className="st0-meter" x1={37.2} y1={49.2} x2={37.2} y2={43} />
				<path
					className="st0-meter"
					d="M34.4,65.4c0-1.5,2.8-5.8,2.8-5.8s2.8,4.3,2.8,5.8s-1.2,2.8-2.8,2.8S34.4,67,34.4,65.4z"
				/>
			</g>
			<path
				className="st0-meter"
				d="M29.5,19c0-4.2,7.7-16,7.7-16s7.7,11.8,7.7,16s-3.4,7.6-7.7,7.6S29.5,23.2,29.5,19z"
			/>
		</svg>
	);
};
